import type { DeleteScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteScimTokenDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type DeleteScimTokenInput = { keyId: string };

export const useDeleteScimToken = createMutationHook({
  name: 'deleteScimToken',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.scim.deleteToken.mutationOptions({ onSuccess }),
  mapInput: (variables: DeleteScimTokenInput) => variables,
  invalidate: (trpc) => [trpc.frontend.scim.getConfig.queryKey()],
  mapResponse: (result: { keyId: string }): DeleteScimTokenMutation => ({
    delete_scim_token: {
      __typename: 'DeleteScimTokenOutput',
      keyId: result.keyId,
    },
  }),
  graphqlDocument: DeleteScimTokenDocument,
  graphqlVariables: (variables: DeleteScimTokenInput) => ({ ...variables }),
  evictFields: ['getScimConfig'],
});
